import { Inputs } from '../../../types';
import { TProjectConfigurationParameter } from '../../../../../entries/common/widgets/project-configuration/context';
import { getProjectConfigurationParameters } from './get-project-configuration-parameters';
import { configurationTypes } from '../../../const';

export const getCreateConfigurationBody = (
  inputsData: Inputs,
  isKazakhstan: boolean,
  customerId: string,
  isAuthorized: boolean
): {
  configurationType: string;
  buCode: number;
  currency: string;
  projectConfigurationParameters: Array<TProjectConfigurationParameter>;
  customerId: string;
  isAuthorized: boolean;
} => {
  const projectConfigurationParameters = getProjectConfigurationParameters(inputsData);

  return {
    configurationType: configurationTypes.INTERIOR_DOORS,
    buCode: isKazakhstan ? 40 : 9,
    currency: isKazakhstan ? 'KZT' : 'RUB',
    projectConfigurationParameters,
    customerId,
    isAuthorized,
  };
};
